<template>
  <main>
    <div class="tab-header">
      <div class="container-fluid">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item" :class="{'active': currentTab===0}">
            <a
              href="#tab-0"
              @click.prevent="resetValid"
              class="nav-link active show"
              role="tab"
              data-toggle="tab"
            >新增同仁眷屬檔</a>
          </li>
          <li class="nav-item" :class="{'active': currentTab===1}">
            <a
              href="#tab-1"
              @click.prevent="resetValid"
              class="nav-link"
              role="tab"
              data-toggle="tab"
            >刪除同仁眷屬檔</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="tab-content">
      <div class="container-fluid">
        <div id="tab-0" class="tab-pane active show" role="tabpanel">
          <section>
            <h3 class="text-green my-4 mx-2">新增同仁眷屬</h3>
            <form data-vv-scope="insert" class="form">
              <table>
                <thead>
                  <tr>
                    <th>
                      業務員ID
                      <span class="waring-block d-inline-block ml-2">
                        <span class="text">必填</span>
                      </span>
                    </th>
                    <th>業務員姓名</th>
                    <th>
                      關係
                      <span class="waring-block d-inline-block ml-2">
                        <span class="text">必填</span>
                      </span>
                    </th>
                    <th>
                      親屬ID
                      <span class="waring-block d-inline-block ml-2">
                        <span class="text">必填</span>
                      </span>
                    </th>
                    <th>親屬姓名</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div class="input">
                        <input
                          maxlength="10"
                          type="text"
                          :data-vv-name="'agid'"
                          v-model="insertData.agid"
                          placeholder="業務員ID"
                          data-vv-as="業務員ID"
                          :class="{ 'is-invalid': errors.has('insert.agid') }"
                          v-validate="'required'"
                          class="form-control"
                        />
                      </div>
                      <span class="waring-text">{{ errors.first('insert.agid') }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="form-control form-control-inline"
                        placeholder="業務員姓名"
                        v-model="insertData.agnm"
                      />
                    </td>
                    <td>
                      <div class="input">
                        <input
                          maxlength="10"
                          type="text"
                          :data-vv-name="'form_no'"
                          v-model="insertData.form_no"
                          placeholder="關係"
                          data-vv-as="關係"
                          :class="{ 'is-invalid': errors.has('insert.form_no') }"
                          v-validate="'required'"
                          class="form-control"
                        />
                      </div>
                      <span class="waring-text">{{ errors.first('insert.form_no') }}</span>
                    </td>
                    <td>
                      <div class="input">
                        <input
                          maxlength="10"
                          type="text"
                          :data-vv-name="'fmlyid'"
                          v-model="insertData.fmlyid"
                          placeholder="親屬ID"
                          data-vv-as="親屬ID"
                          :class="{ 'is-invalid': errors.has('insert.fmlyid') }"
                          v-validate="'required'"
                          class="form-control"
                        />
                      </div>
                      <span class="waring-text">{{ errors.first('insert.fmlyid') }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="form-control form-control-inline"
                        placeholder="親屬姓名"
                        v-model="insertData.fmlynm"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td colspan="5" style="text-align: center;">
                      <a href="#" @click.prevent="insertAGFamily" class="btn btn-primary mt-0">確定</a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </form>
          </section>
        </div>
        <div id="tab-1" class="tab-pane" role="tabpanel">
          <section>
            <h3 class="text-green my-4 mx-2">刪除同仁眷屬</h3>
            <form data-vv-scope="delete" class="form">
              <table>
                <thead>
                  <tr>
                    <th>
                      業務員ID
                      <span class="waring-block d-inline-block ml-2">
                        <span class="text">必填</span>
                      </span>
                    </th>
                    <th>
                      親屬ID
                      <span class="waring-block d-inline-block ml-2">
                        <span class="text">必填</span>
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div class="input">
                        <input
                          maxlength="10"
                          type="text"
                          :data-vv-name="'agid'"
                          v-model="deleteData.agid"
                          placeholder="業務員ID"
                          data-vv-as="業務員ID"
                          :class="{ 'is-invalid': errors.has('delete.agid') }"
                          v-validate="'required'"
                          class="form-control"
                        />
                      </div>
                      <span class="waring-text">{{ errors.first('delete.agid') }}</span>
                    </td>
                    <td>
                      <div class="input">
                        <input
                          maxlength="10"
                          type="text"
                          :data-vv-name="'fmlyid'"
                          v-model="deleteData.fmlyid"
                          placeholder="親屬ID"
                          data-vv-as="親屬ID"
                          :class="{ 'is-invalid': errors.has('delete.fmlyid') }"
                          v-validate="'required'"
                          class="form-control"
                        />
                      </div>
                      <span class="waring-text">{{ errors.first('delete.fmlyid') }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2" style="text-align: center;">
                      <a href="#" @click.prevent="deleteAGFamily" class="btn btn-primary mt-0">刪除</a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </form>
          </section>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import { commonMixin } from "@/mixins/common";
//import { Validator } from "vee-validate";
import { mapGetters } from "vuex";
import { addAGFamily, deleteAGFamily } from "@/service";
export default {
  name: "addAGFamily",
  mixins: [commonMixin],
  data() {
    return {
      insertData: {
        agid: "",
        agnm: "",
        form_no: "",
        fmlyid: "",
        fmlynm: "",
        create_id: this.$store.state.userInfo.id
      },
      deleteData: {
        agid: "",
        fmlyid: ""
      }
    };
  },
  computed: {
    ...mapGetters(["BaseUrl", "FamilyResultFilter", "UserInfo"])
  },
  methods: {
    resetValid() {
      this.$validator.reset();
    },
    insertAGFamily() {
      this.$validator.validateAll("insert").then(el => {
        if (!el) {
          const errMsg =
            this.errors.items.length > 1
              ? "尚有必填欄位待確認"
              : this.errors.items[0].msg;
          this.$toast.info({ title: errMsg });
          return;
        }
        addAGFamily(this.UserInfo.id, this.insertData).then(result => {
          if (result.header && result.header.status == "200") {
            this.$toast.info({ title: "眷屬資料新增成功" });
            this.insertData = {
              agid: "",
              agnm: "",
              form_no: "",
              fmlyid: "",
              fmlynm: "",
              create_id: this.$store.state.userInfo.id
            };
          } else {
            this.$toast.info({ title: result.header.message });
          }
        });
      });
    },
    deleteAGFamily() {
      this.$validator.validateAll("delete").then(el => {
        if (!el) {
          const errMsg =
            this.errors.items.length > 1
              ? "尚有必填欄位待確認"
              : this.errors.items[0].msg;
          this.$toast.info({ title: errMsg });
          return;
        }
        deleteAGFamily(this.UserInfo.id, this.deleteData).then(result => {
          if (result.header && result.header.status == "200") {
            this.$toast.info({ title: "眷屬資料刪除成功" });
            this.deleteData = {
              agid: "",
              fmlyid: ""
            };
          } else {
            this.$toast.info({ title: result.header.message });
          }
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.dropdown-menu-left {
  left: -16px !important;
}
.filter-result-table thead tr,
.filter-result-table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}
.list.badgets .badget.gray.item {
  padding: 0 22px;
  color: #323a45;
  background: #e0e1e3;
  border-radius: 8px;
  margin-right: 10px;
  margin-top: 10px;
}

.waring-block {
  .text {
    width: 47px;
    height: 18px;
    font-size: 13px;
    color: #323a45;
    line-height: 13px;
    position: relative;
    padding: 3px 0 0 12px;
  }

  .text.lg {
    flex: 1;
    width: auto;
    padding-right: 4px;
  }
  .text::before {
    position: absolute;
    content: "*";
    color: red;
    top: 6px;
    left: 6px;
  }
}

.waring-text {
  margin-top: 5px;
  font-size: 13px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #de4054;
}

.clearPosition {
  position: absolute;
  right: 15px;
  top: 45px;
}

.filter-result-table tbody {
  display: block;
  height: 400px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 17px;
    border: 0;
    box-shadow: none;
  }

  &::-webkit-scrollbar-track {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
}
</style>
